import api from '../index';

export interface SocialNetworkUnlinkResponse {
  success: boolean;
  message?: string;
}

export interface SocialNetworkError {
  errors: string[];
}

/**
 * Unlinks a social network account
 * @param network - The social network to unlink (e.g., 'instagram', 'tiktok')
 * @returns Promise that resolves on successful unlink
 */
export const unlinkSocialNetwork = async (
  network: string
): Promise<SocialNetworkUnlinkResponse> => {
  const response = await api.post<SocialNetworkUnlinkResponse>(
    `/social_networks/${network}/unlink`,
    {}
  );
  if (!response) {
    throw new Error('Failed to unlink social network: got empty response');
  }
  // Todo: check response for errors and parse them into SocialNetworkError
  return response as SocialNetworkUnlinkResponse;
};

export default {
  unlinkSocialNetwork,
};
